enum Ordering {
  Equal = 0,
  Greater = 1,
  Less = -1
}

export default Ordering;
